class UVPSCarousel extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    window.loadSwiper.then((swiperLib) => {
      this.swiperLib = swiperLib;

      this._initCarousel();
    });
  }

  disconnectedCallback() {}

  _initCarousel() {
    const { Swiper } = this.swiperLib;

    const swiperParams = {
      slidesPerView: "auto",
      speed: 300,
      spaceBetween: 80,
      centerInsufficientSlides: true,
      navigation: {
        nextEl: this.querySelector("[data-navigation-next]"),
        prevEl: this.querySelector("[data-navigation-previous]"),
      },
      breakpoints: {
        960: {
          spaceBetween: 40,
        },
      },
      on: {
        lock: () => {
          this.classList.add("uvps__carousel--locked");
        },
        unlock: () => {
          this.classList.remove("uvps__carousel--locked");
        },
      },
    };

    this.swiper = new Swiper(this, swiperParams);
  }
}

if (!customElements.get("uvps-carousel")) {
  customElements.define("uvps-carousel", UVPSCarousel);
}
